import { createClient } from '@/shared/api';
import type {
  MarkDevicePatientReturnedMutation,
  MarkDevicePatientReturnedMutationVariables,
} from '@/shared/api';
import MASK_DEVICE_PATIENT_RETURNED from '../mutations/markDevicePatientReturned';

/**
 * Records that the patient has returned a device. Runs the markDevicePatientReturned mutation and throws the first GraphQL error, or the returned message when it does not report success.
 *
 * @param input - Mutation input identifying the returned device; defaults to an empty object.
 * @returns A promise resolving once the device has been marked returned.
 */
const handleMarkDevicePatientReturned = async (input = {}) => {
  const client = createClient();
  const result = await client.mutate<
    MarkDevicePatientReturnedMutation,
    MarkDevicePatientReturnedMutationVariables
  >({
    mutation: MASK_DEVICE_PATIENT_RETURNED,
    variables: {
      input,
    },
  });
  const { data, errors } = result;
  if (errors?.length) {
    throw new Error(errors[0].message);
  }
  // data is always present once the errors check above has passed
  const { markDevicePatientReturned } = data!;
  if (!markDevicePatientReturned?.isSuccess) {
    throw new Error(markDevicePatientReturned?.message ?? undefined);
  }
};

export default handleMarkDevicePatientReturned;
